import React from "react";
import Image from "components/image";
import SrOnly from "components/sr-only";

const Review = ({ review }) => (
    <div className="flex flex-col h-full bg-white rounded-md">
        <Image className="w-58 h-52 bg-transparent rounded-t-md hover:cursor-pointer" imgClassName="image-hover-effect" image={review.image.asset} />
        <div className="flex flex-col p-3 pt-4 flex-1">
            <div className="w-[calc(100%-60px)] flex flex-col justify-between h-full">
                <div> 
                    <p className="font-semibold text-xs pb-1.5">{review.title}</p>
                    <SrOnly label={review.title} />
                </div>
                <div>
                    <p className="text-gray-701 text-sm">
                        {review.userHandle}
                    </p>
                    <SrOnly label={review.userHandle} />
                </div>
            </div>
        </div>
    </div>
);

export default Review;
